import ColoredMarker from "./ColoredMarker";
import {
  getServiceOrderManagedByValuesByBoolean,
  getServiceOrderManagedByValuesByLabel,
} from "../../_constants/serviceOrder.ts";

const ServiceManagedByComponent = ({
  isManagedByMainGroup,
  label,
}: {
  isManagedByMainGroup?: boolean;
  label?: string;
}) => {
  const value = label
    ? getServiceOrderManagedByValuesByLabel(label)
    : getServiceOrderManagedByValuesByBoolean(isManagedByMainGroup);
  return (
    <ColoredMarker className={"text-nowrap"} color={value?.color || "#000D5B"}>
      {value?.label}
    </ColoredMarker>
  );
};

export default ServiceManagedByComponent;
